import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const LimbPosition = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Limb Position</InputLabel>
      <Select
        value={moduleValues?.['Limb Position'] ?? ''}
        label='Limb Position'
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Limb Position']: e.target.value,
          }))
        }
      >
        {['Position Found', 'Adjusted for Comfort', 'Anatomical Position'].map(
          (x) => (
            <MenuItem key={x} value={x}>
              {x}
            </MenuItem>
          )
        )}
      </Select>
    </FormControl>
  </Grid>
)

export default LimbPosition
